import { Instagram, Facebook, Mail, Phone, MapPin } from "lucide-react";
import { whatsappLink, EMAIL, PHONE_DISPLAY, ADDRESS, INSTAGRAM, FACEBOOK } from "../../lib/api";
import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer id="connect" className="relative bg-charcoal text-cream grain overflow-hidden">
      <div className="mx-auto max-w-[1600px] px-6 md:px-10 py-24 md:py-32 relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-14">
          <div className="lg:col-span-6">
            <p className="text-xs tracking-[0.28em] uppercase font-bold text-toga mb-6">Visit Us</p>
            <div className="flex items-start gap-4 mb-6">
              <MapPin className="text-toga mt-1 shrink-0" size={20} />
              <p className="font-body text-lg text-cream/85 max-w-md leading-relaxed">{ADDRESS}</p>
            </div>
            <a href={`tel:${PHONE_DISPLAY.replace(/\s/g, "")}`} className="flex items-center gap-4 mb-3 hover:text-toga transition-colors">
              <Phone className="text-toga" size={20} /> <span className="text-lg">{PHONE_DISPLAY}</span>
            </a>
            <a href={`mailto:${EMAIL}`} className="flex items-center gap-4 mb-8 hover:text-toga transition-colors">
              <Mail className="text-toga" size={20} /> <span className="text-lg">{EMAIL}</span>
            </a>
            <div className="flex items-center gap-5">
              <a href={INSTAGRAM} target="_blank" rel="noreferrer" data-testid="footer-instagram" className="p-3 border border-cream/20 hover:border-toga hover:text-toga transition-colors"><Instagram size={20} /></a>
              <a href={FACEBOOK} target="_blank" rel="noreferrer" data-testid="footer-facebook" className="p-3 border border-cream/20 hover:border-toga hover:text-toga transition-colors"><Facebook size={20} /></a>
              <a href={whatsappLink("Hello TOGA!")} target="_blank" rel="noreferrer" data-testid="footer-whatsapp" className="px-6 py-3 bg-toga text-white text-xs uppercase tracking-[0.15em] font-bold hover:bg-cream hover:text-charcoal transition-colors">WhatsApp Us</a>
            </div>
          </div>

          <div className="lg:col-span-6 lg:text-right flex flex-col lg:items-end justify-between">
            <div>
              <p className="text-xs tracking-[0.28em] uppercase font-bold text-cream/50 mb-4">Hours</p>
              <p className="text-cream/85 text-lg">Mon – Sun · 10:00 AM – 10:00 PM</p>
            </div>
            <Link to="/admin/login" data-testid="footer-admin-link" className="text-xs tracking-[0.28em] uppercase text-cream/40 hover:text-toga transition-colors mt-10">Admin</Link>
          </div>
        </div>

        <div className="mt-16 pt-10 border-t border-cream/15 flex flex-col md:flex-row md:items-end md:justify-between gap-8">
          <h2 className="font-display font-black leading-[0.82] text-[22vw] md:text-[16vw] lg:text-[12vw] tracking-tighter text-toga">TOGA</h2>
          <p className="text-cream/40 text-xs uppercase tracking-[0.2em] mb-4">© {new Date().getFullYear()} Toga Menswear · Vashi, Navi Mumbai</p>
        </div>
      </div>
    </footer>
  );
}
